:where(button) {
  all: unset;
  display: flex;
  user-select: none;
  touch-action: manipulation;
  -webkit-user-drag: element;
}

*,
::before,
::after {
  box-sizing: border-box;
}

:host {
  --ch-tree-view-view__checkbox-size: 1em;
  --ch-tree-view-view__expandable-button-width: 0.75em;
  --ch-tree-view-item__dashed-line--inset-inline-start: 0px;
  --ch-tree-view-item__dashed-line--inset-inline-end: 4px;
  --ch-tree-view-item-gap: 5px;
  --ch-tree-view-item-custom-padding-inline-start: 0px;
  --ch-tree-tab-width: calc(
    var(--ch-tree-view-view__checkbox-size) +
      var(--ch-tree-view-view__expandable-button-width) +
      (var(--ch-tree-view-item-gap) * 2)
  );
  display: grid;
  grid-template-rows: min-content;
}

.header {
  --own-offset: 0px;
  display: flex;
  align-items: center;
  min-height: calc(1em + 6px);
  padding-inline-start: calc( var(--padding-inline-start) + var(--ch-tree-view-item-custom-padding-inline-start) );
}
.header--disabled {
  opacity: 0.5;
  pointer-events: none;
}
.header--even {
  --padding-inline-start: calc(
    var(--parent-padding-inline-start--odd, 0px) + var(--ch-tree-tab-width)
  );
}
.header--even + .expandable {
  --parent-padding-inline-start--even: calc(
    var(--parent-padding-inline-start--odd, 0px) + var(--ch-tree-tab-width)
  );
}
.header--even .dashed-line {
  --inset-inline-start: calc(
    var(--parent-padding-inline-start--odd, 0px) +
      var(--parent-checkbox-offset) + var(--parent-expandable-offset)
  );
}
.header--even-expandable {
  --padding-inline-start: calc(
        var(--parent-padding-inline-start--odd, 0px) + var(--ch-tree-tab-width) -
          calc(
    var(--ch-tree-view-view__expandable-button-width) +
      var(--ch-tree-view-item-gap)
  )
      );
}
.header--even-expandable + .expandable {
  --parent-padding-inline-start--even: calc(
        var(--parent-padding-inline-start--odd, 0px) + var(--ch-tree-tab-width) -
          calc(
    var(--ch-tree-view-view__expandable-button-width) +
      var(--ch-tree-view-item-gap)
  )
      );
}
.header--odd {
  --padding-inline-start: calc(
    var(--parent-padding-inline-start--even, 0px) + var(--ch-tree-tab-width)
  );
}
.header--odd + .expandable {
  --parent-padding-inline-start--odd: calc(
    var(--parent-padding-inline-start--even, 0px) + var(--ch-tree-tab-width)
  );
}
.header--odd .dashed-line {
  --inset-inline-start: calc(
    var(--parent-padding-inline-start--even, 0px) +
      var(--parent-checkbox-offset) + var(--parent-expandable-offset)
  );
}
.header--odd-expandable {
  --padding-inline-start: calc(
        var(--parent-padding-inline-start--even, 0px) + var(--ch-tree-tab-width) -
          calc(
    var(--ch-tree-view-view__expandable-button-width) +
      var(--ch-tree-view-item-gap)
  )
      );
}
.header--odd-expandable + .expandable {
  --parent-padding-inline-start--odd: calc(
        var(--parent-padding-inline-start--even, 0px) + var(--ch-tree-tab-width) -
          calc(
    var(--ch-tree-view-view__expandable-button-width) +
      var(--ch-tree-view-item-gap)
  )
      );
}
.header--level-0 {
  --padding-inline-start: 0px;
}
.header--level-0 + .expandable {
  --parent-padding-inline-start--even: 0px;
}
.header--expandable-offset {
  --own-offset: calc(
    var(--ch-tree-view-view__expandable-button-width) +
      var(--ch-tree-view-item-gap)
  );
}
.header--expandable-offset + .expandable {
  --parent-expandable-offset: calc(
    var(--ch-tree-view-view__expandable-button-width) / 2
  );
}
.header--checkbox-offset + .expandable {
  --parent-checkbox-offset: calc(
    var(--ch-tree-view-view__checkbox-size) / 2
  );
  --parent-negative-checkbox-offset: calc(
    var(--ch-tree-view-view__checkbox-size) / 2
  );
}

.dashed-line {
  position: absolute;
  inset-inline-start: calc( var(--inset-inline-start) + var(--ch-tree-view-item__dashed-line--inset-inline-start) + var(--ch-tree-view-item-custom-padding-inline-start) );
  height: 1px;
  width: calc( var(--ch-tree-tab-width) - var(--parent-checkbox-offset) - var(--parent-expandable-offset) - var(--own-offset) - var(--ch-tree-view-item__dashed-line--inset-inline-start) - var(--ch-tree-view-item__dashed-line--inset-inline-end) );
  border: 0 dashed color-mix(in srgb, currentColor 65%, transparent);
  border-block-end-width: 1px;
  pointer-events: none;
  content-visibility: hidden;
  z-index: 1;
}

.last-all-line {
  inset-block-start: 0;
  height: calc(100% - var(--ch-tree-view-item-distance-to-checkbox));
  border-inline-start-width: 1px;
  border-end-start-radius: 2px;
}

.last-line {
  inset-block-start: 0;
  height: 100%;
  border-inline-start-width: 1px;
  border-style: solid;
  border-block-end: unset;
}

.expandable-button,
.expandable-button-decorative::before {
  display: grid;
  place-items: center;
  width: var(--ch-tree-view-view__expandable-button-width);
  height: var(--ch-tree-view-view__expandable-button-width);
  margin-inline-end: var(--ch-tree-view-item-gap);
  z-index: 1;
  cursor: pointer;
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-tree-view-view__expandable-button-width);
}

.expandable-button-decorative::before {
  content: "";
  background-color: currentColor;
  -webkit-mask: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>') 50% 50%/calc(100% - 2px) calc(100% - 2px) no-repeat;
  cursor: unset;
}
.expandable-button-decorative--collapsed::before {
  transform: rotate(-90deg);
}
.expandable-button::before {
  content: "";
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background-color: currentColor;
  -webkit-mask-size: calc( var(--ch-tree-view-view__expandable-button-width) - 2px );
}
.expandable-button--collapsed::before {
  -webkit-mask-image: url('data:image/svg+xml,<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.15,8.5H8.54v5.61h-1V8.5H1.93v-1H7.54V1.89h1V7.5h5.61Z"/></svg>');
}
.expandable-button--expanded::before {
  -webkit-mask-image: url('data:image/svg+xml,<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.15,8.5H1.93v-1H14.15Z"/></svg>');
}
.expandable-button:focus-visible {
  outline: 1px solid #000;
}

.checkbox {
  width: var(--ch-tree-view-view__checkbox-size);
  margin-inline-end: var(--ch-tree-view-item-gap);
}
.checkbox::part(container) {
  width: var(--ch-tree-view-view__checkbox-size);
  height: var(--ch-tree-view-view__checkbox-size);
}

.action {
  display: grid;
  grid-template: "left-img text right-img"/max-content 1fr max-content;
  align-items: center;
  height: 100%;
  flex: 1;
  cursor: pointer;
}

.readonly-mode {
  padding-block: 0.75px;
}

.left-img,
.right-img {
  display: block;
  width: 0.875em;
  height: 0.875em;
  content-visibility: auto;
  contain-intrinsic-size: auto 0.875em;
}

.left-img {
  grid-area: left-img;
  margin-inline-end: var(--ch-tree-view-item-gap);
}

.right-img {
  grid-area: right-img;
  margin-inline-start: var(--ch-tree-view-item-gap);
}

.edit-name {
  grid-area: text;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: unset;
  color: unset;
  border: 1px solid currentColor;
  font: unset;
  outline: unset;
}

.downloading {
  width: 0.75em;
  height: 0.75em;
  margin-inline: 8px 2px;
  border: 2px solid currentColor;
  border-inline-start-color: transparent;
  border-radius: 50%;
  opacity: 0.75;
  animation: spin 1s linear infinite, avoid-flickering 75ms;
}

@keyframes avoid-flickering {
  0%, 100% {
    display: none;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.expandable {
  --parent-expandable-offset: 0px;
  --parent-negative-checkbox-offset: 0px;
  --parent-checkbox-offset: 0px;
  display: grid;
  grid-auto-rows: min-content;
  position: relative;
}
.expandable--lazy-loaded {
  content-visibility: auto;
  contain-intrinsic-size: auto 100px;
}

.expandable--collapsed {
  display: none;
  overflow: hidden;
}